import app from 'flarum/forum/app';
import {ApiResponsePlural} from 'flarum/common/Store';
import Album from '../models/Album';

export default class AlbumListState {
    params: any
    albums: Album[] = []
    moreResults: boolean = false
    loading: boolean = true

    constructor(params: any = {}) {
        this.params = params;
    }

    requestParams() {
        const params: any = {filter: {}};

        params.sort = this.sortMap()[this.params.sort];

        if (this.params.q) {
            params.filter.q = this.params.q;
        }

        return params;
    }

    sortMap() {
        const map: any = {};

        map.latest = '-createdAt';
        map.oldest = 'createdAt';
        map.latestTake = '-takenAt';
        map.oldestTake = 'takenAt';

        return map;
    }

    clear() {
        this.albums = [];
        m.redraw();
    }

    refresh({deferClear = false} = {}) {
        this.loading = true;

        if (!deferClear) {
            this.clear();
        }

        return this.loadResults().then(
            results => {
                this.albums = [];
                this.parseResults(results);
            },
            () => {
                this.loading = false;
                m.redraw();
            }
        );
    }

    loadResults(offset = 0): Promise<ApiResponsePlural<Album>> {
        const preloadedAlbums = app.preloadedApiDocument<Album[]>();

        if (preloadedAlbums) {
            return Promise.resolve(preloadedAlbums);
        }

        const params = this.requestParams();
        params.page = {offset};

        return app.store.find<Album[]>('cimaise/albums', params);
    }

    loadMore() {
        this.loading = true;

        this.loadResults(this.albums.length)
            .then(this.parseResults.bind(this));
    }

    parseResults(results: ApiResponsePlural<Album>) {
        this.albums.push(...results);

        this.loading = false;
        this.moreResults = !!results.payload.links && !!results.payload.links.next;

        m.redraw();

        return results;
    }

    removeAlbum(album: Album) {
        const index = this.albums.indexOf(album);

        if (index !== -1) {
            this.albums.splice(index, 1);
        }
    }

    addAlbum(album: Album) {
        this.albums.unshift(album);
    }
}
